import { render, staticRenderFns } from "./GiftsItem.vue?vue&type=template&id=45707952&scoped=true&"
import script from "./GiftsItem.vue?vue&type=script&lang=js&"
export * from "./GiftsItem.vue?vue&type=script&lang=js&"
import style0 from "./GiftsItem.vue?vue&type=style&index=0&id=45707952&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45707952",
  null
  
)

export default component.exports